import React from 'react';

var GameHolder = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-game-holder' }, children));
};

export { GameHolder };
